import React from "react";
import {createAction} from "redux-act";

export interface IMessageResponse {
	id: number;
	type: string;
	title: string;
	text: string;
}

export interface IBanner {
	Icon?: React.FC;
	image?: string | null;
	title: string;
	description?: string;
	redirectUrl?: string;
}

export const fetchMessageSuccess = createAction<IMessageResponse>();
export const fetchMessageFailed = createAction();
export const showBanner = createAction<IBanner>();
export const showBannerDebug = createAction();
export const hideBanner = createAction();
